import { useToggle } from '../hooks/UNSAFE_useToggle';

export type HoverOptions = {
  onMouseEnter: (e: MouseEvent) => void;
  onMouseLeave: (e: MouseEvent) => void;
};
/**
 * Returns listeners and status for hover
 *
 *
 * @returns
 */
export function useSubmenuItemHover(settings: HoverOptions): {
  hoverProps: Record<string, any>;
} {
  const { bool: ignore, setTrue: setIgnoreTrue, setFalse: setIgnoreFalse } = useToggle(false);
  const startHover = (e: MouseEvent) => {
    if (ignore) {
      setIgnoreFalse();
    } else {
      settings.onMouseEnter(e);
    }
  };

  const hoverProps = {
    ontouchend: setIgnoreTrue,
    onMouseEnter: startHover,
    onMouseLeave: (e: MouseEvent) => {
      settings.onMouseLeave(e);
    }
  };
  return {
    hoverProps: hoverProps
  };
}
